import { type ReactElement } from 'react';

import styles from './palmares-filter.module.scss';
import { Font } from '@utmb/design-system/text/font';
import { Icon } from '@utmb/design-system/icons/Icon';
import { IconsEnum } from '@utmb/types/icons';
import type { PalmaresSortKey, PalmaresSortState } from '../palmares-table';
import { useTranslation } from 'next-i18next';

export interface PalmaresFilterProps {
    sortState: PalmaresSortState;
    onSort: (key: PalmaresSortKey) => void;
    hasDeleteColumn?: boolean;
    isAuthenticated: boolean;
}

export function PalmaresFilter({ sortState, onSort, hasDeleteColumn = false, isAuthenticated }: PalmaresFilterProps): ReactElement {
    const { t } = useTranslation();
    const COLUMNS: Array<{ key: PalmaresSortKey; label: string }> = [
        { key: 'date', label: t('common.date') },
        { key: 'race', label: t('singleRunner.resultsTable.race') },
        { key: 'score', label: t('singleRunner.resultsTable.score') },
        { key: 'distance', label: t('singleRunner.resultsTable.distance') },
        { key: 'time', label: t('singleRunner.resultsTable.time') },
        { key: 'scratch', label: t('singleRunner.resultsTable.rank') },
        { key: 'gender', label: t('singleRunner.resultsTable.rankGender') },
    ];
    return (
        <div className={`${styles.palmaresFilter} ${hasDeleteColumn ? '' : styles.noDelete} ${isAuthenticated ? '' : styles.notAuthenticated}`}>
            {COLUMNS.map(({ key, label }) => {
                const isActive = sortState?.key === key;
                return (
                    <button key={key} type="button" className={styles.filter} onClick={() => onSort(key)}>
                        <Font.FuturaBook as="span" desktop="20" mobile="16">
                            {label}
                        </Font.FuturaBook>
                        {isActive && <Icon width={16} height={16} variant={sortState.direction === 'asc' ? IconsEnum.CHEVRON_UP : IconsEnum.CHEVRON_DOWN} />}
                    </button>
                );
            })}
        </div>
    );
}
